module.exports = __webpack_public_path__ + "media/app/assets/lighter-hero-background-7cacffab45cc7ffba5f43165f46ae364.png";